import { IEmbeddingMessagesTriggerProps } from '../types';
import { useAuthMessageTriggers } from './auth';
import { useIntroMessageTriggers } from './intro';
import { useReadyMessageTriggers } from './ready';

export const useOutgoingMessageTriggers = (props: IEmbeddingMessagesTriggerProps) => {
  useAuthMessageTriggers(props);
  useIntroMessageTriggers(props);
  useReadyMessageTriggers(props);
};
